import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GlobeCanvas } from "@app/components/GlobeCanvas.tsx";
import { Countdown } from "@app/components/Countdown.tsx";
import { LegalLinks } from "@app/components/LegalLinks.tsx";
import { useGame } from "@app/state/game.ts";
import { formatGameDate } from "@app/format.ts";
import { track } from "@app/analytics.ts";

export function Home() {
  const navigate = useNavigate();
  const round = useGame((s) => s.round);
  const streak = useGame((s) => s.currentStreak);
  const error = useGame((s) => s.error);
  const load = useGame((s) => s.load);

  useEffect(() => {
    track({ name: "app_open" });
    if (!round) void load();
  }, [round, load]);

  const start = () => {
    track({ name: "round_start", roundId: round?.id ?? null });
    navigate("/jugar");
  };

  return (
    <section className="screen" aria-labelledby="homeTitle">
      <div className="hero">
        <div className="hero__globe">
          <GlobeCanvas spin fill={0.46} maxDpr={1.25} />
        </div>
        <h1 className="hero__title" id="homeTitle">
          ¿Dónde
          <br />
          <span>ocurrió?</span>
        </h1>
        <p className="hero__lede">
          5 pistas de fútbol cada día. Toca en el globo dónde pasó y compártelo con tu grupo.
        </p>
        <div className="roundcard">
          <div>
            <div className="roundcard__k">Ronda de hoy</div>
            <div className="roundcard__v">
              {round ? `#${round.number} · ${formatGameDate(round.gameDate)}` : "Cargando…"}
            </div>
          </div>
          <div className="roundcard__meta">
            Racha <b>{streak ?? 0}</b>
            <br />
            Nueva en {round ? <Countdown targetIso={round.nextRolloverAt} /> : "—"}
          </div>
        </div>
        <button type="button" className="cta" onClick={start} disabled={!round}>
          Jugar
        </button>
        {error ? (
          <p className="status" role="alert">
            {error}
          </p>
        ) : null}
        <LegalLinks />
      </div>
    </section>
  );
}
